<script>
import {defineComponent} from 'vue'
import ClLoading from "@/components/base/ClLoading.vue";

export default defineComponent({
  name: "ClLoadingOverlay",
  props: {
    /**
     * @description v-model for start/stop loading
     * @type {boolean}
     * */
    modelValue: {
      type: Boolean,
      default: false
    },
    /**
     * @description to handle full screen mode or block mode loading
     * @type {boolean}
     * */
    contained: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  data(){
    return {
      value: false
    }
  },
  watch: {
    modelValue: {
      handler: function (value){
        this.value = value;
      },
      immediate: true,
    },
  },
  methods: {
    close(){
      this.value = false;
      this.$emit('update:modelValue', false)
    }
  },
  components: {ClLoading}
})
</script>

<template>
  <v-overlay
      v-model="value"
      :contained="contained"
      class="align-center justify-center"
      data-test="overlay-loading"
  >
    <ClLoading />
  </v-overlay>
</template>


